<script setup lang="ts">
import { computed, defineProps, withDefaults } from "vue";
import AudioComp from "@/views/AIGenerate/components/AudioComp.vue";

const props = withDefaults(
  defineProps<{
    name: string;
    phonetic: string;
    definition: string;
    root: string;
  }>(),
  {
    name: "",
    phonetic: "",
    definition: "",
    root: "",
  }
);
const title = computed(() =>
  props.name.replace(
    props.root.replace("-", ""),
    `<span style="color: #FF5323;">${props.root.replace("-", "")}</span>`
  )
);
</script>

<template>
  <div class="box">
    <div class="word" v-html="title" />
    <div class="description">
      {{ props.definition }}
    </div>
    <div v-if="props.phonetic" class="phonetic">
      {{ props.phonetic }}
      <AudioComp :word="props.name" class="audio" />
    </div>
  </div>
</template>

<style scoped lang="less">
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform: scale(0.85);
  width: 100%;
  height: 100%;
  .word {
    font-size: 1.21rem;
    color: #2a1f10;
    margin-bottom: 0.2rem;
    font-weight: 600;
    text-align: center;
    width: 100%;
  }

  .phonetic {
    padding: 0.2rem 0.4rem;
    border-radius: 1rem;
    background: #fccda2;
    color: #101214;
    font-size: 0.74rem;
    line-height: 1.2;
    display: inline-flex;
    align-items: center;
    word-break: break-all;
    width: fit-content !important;
    .audio {
      font-size: 1.1rem;
    }

    .bofang-icon {
      width: 1.21rem;
    }
  }
  .description {
    margin-bottom: 0.2rem;
    font-size: 0.81rem;
    color: #938f87;
    line-height: 2;
  }
}
</style>
